import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HealthPage = lazy(() => import('../components/HealthPage'));
const CampaignOpsPage = lazy(() => import('../components/CampaignOpsPage'));

const HealthRoutes: RouteObject[] = [
  {
    path: 'health',
    element: <HealthPage />,
  },
  {
    // Live view of the chunked campaign execution flow. Open to any authenticated user: internal
    // users get every tenant plus the controls, everyone else gets their own tenant, read only.
    path: 'health/campaigns',
    element: <CampaignOpsPage />,
  },
];

export default HealthRoutes;
